module.exports = __webpack_public_path__ + "static/media/Chris Liu.ecdb2fb4.png";